import React from "react";
import clsx from "clsx";
const Spinner = ({ className }) => {
  return (
    <div className={clsx("spinner-border", className)} role="status"></div>
  );
};

export default Spinner;
